<form [formGroup]="parentForm">
  <div class="flex flex-col gt-xs:flex-row">
    <input [formControlName]="'id'" type="hidden" />
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Contact Name</mat-label>
      <input
        matInput
        [formControlName]="'name'"
        [placeholder]="'Search by Contact Name or Company Name'"
        [matAutocomplete]="matAutocomplete"
        [spellcheck]="false"
      />
    </mat-form-field>
    <mat-autocomplete
      #matAutocomplete="matAutocomplete"
      [disableRipple]="true"
      (optionSelected)="autocompleteSelected($event)"
    >
      <mat-option disabled class="no-results" *ngIf="contactResults && !contactResults.length"> No contacts found! </mat-option>

      <mat-option *ngFor="let contactResult of contactResults" [value]="contactResult">
        {{ contactResult.name }} ({{ contactResult.category_name }})
      </mat-option>
    </mat-autocomplete>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Contact Type</mat-label>
      <mat-select [formControlName]="'category_id'">
        <mat-option *ngFor="let category of categories" [value]="category.id">
          {{ category.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Company</mat-label>
      <input
        matInput
        [formControlName]="'company_name'"
        [placeholder]="'Company Name'"
        [matAutocomplete]="matAutocompleteCompany"
        [spellcheck]="false"
      />
    </mat-form-field>
    <mat-autocomplete
      #matAutocompleteCompany="matAutocomplete"
      [disableRipple]="true"
      (optionSelected)="autocompleteCompanySelected($event)"
    >
      <mat-option class="no-results" *ngIf="companyResults && !companyResults.length"> No companies found! </mat-option>

      <mat-option *ngFor="let companyResult of companyResults" [value]="companyResult">
        {{ companyResult }}
      </mat-option>
    </mat-autocomplete>
  </div>

  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Email</mat-label>
      <input matInput [formControlName]="'email'" [placeholder]="'Email'" />
    </mat-form-field>
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Phone</mat-label>
      <input
        matInput
        [formControlName]="'phone'"
        [placeholder]="'Phone'"
        [value]="parentForm.get('phone').value | phone"
        digitOnly
      />
    </mat-form-field>
  </div>
</form>
